import React from 'react';

const config = {
  source: {
    columns: [
      {
 title: 'First Name', dataIndex: 'first_name', width: '150px', sorter: true
},
      {
 title: 'Last Name', dataIndex: 'last_name', width: '150px', sorter: true, defaultSortOrder: 'ascend'
},
      {
 title: 'Email', dataIndex: 'email', width: '220px', sorter: true
},
      {
 title: 'Supervisor Email', dataIndex: 'supervisor_email', width: '220px', sorter: true
}
    ],
    confirmMessage: () => (<div />),
    sorter: { field: 'last_name', order: 'ascend' },
    filters: {},
    customFilters: {
      first_name: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['first_name'],
searchValue: ''
      },
      last_name: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['last_name'],
searchValue: ''
      },
      email: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['email'],
searchValue: ''
      },
      supervisor_email: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['supervisor_email'],
searchValue: ''
      }
    },
    title: 'Select Users',
    pageSize: 15,
    persistSelection: true,
    rowSelectionConfig: {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: true
    }
  },
  destination: {
    columns: [
      {
 title: 'First Name', dataIndex: 'first_name', width: '150px', sorter: true
},
      {
 title: 'Last Name', dataIndex: 'last_name', width: '150px', sorter: true, defaultSortOrder: 'ascend'
},
      {
 title: 'Email', dataIndex: 'email', width: '220px', sorter: true
},
      {
 title: 'Supervisor Email', dataIndex: 'supervisor_email', width: '220px', sorter: true
}
    ],
    sorter: { field: 'last_name', order: 'ascend' },
    filters: {},
    customFilters: {
      first_name: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['first_name'],
searchValue: ''
      },
      last_name: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['last_name'],
searchValue: ''
      },
      email: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['email'],
searchValue: ''
      },
      supervisor_email: {
        filterDropdownVisible: false,
filtered: false,
        contains: true,
searchFields: ['supervisor_email'],
searchValue: ''
      }
    },
    title: 'Assigned Users',
    pageSize: 15,
    persistSelection: true,
    rowSelectionConfig: {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: true
    }
  }
};

export default config;
